import { render, staticRenderFns } from "./CommunitySearch.vue?vue&type=template&id=218c5cf4&scoped=true"
import script from "./CommunitySearch.vue?vue&type=script&lang=js"
export * from "./CommunitySearch.vue?vue&type=script&lang=js"
import style0 from "./CommunitySearch.vue?vue&type=style&index=0&id=218c5cf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218c5cf4",
  null
  
)

export default component.exports